<div>{{errorMsg}}</div>

<!--Don't open image in another tab'-->
<!--<dx-data-grid id="gridContainer"
              [dataSource]="recsresults"
              [masterDetail]="{ enabled: false, template: 'detail' }"
              keyExpr="rowId"
              (onInitialized)="onInitialized($event)"
              (onRowExpanding)="onExpanding($event)"
              [showBorders]="true"
              [columnHidingEnabled]="true"
              (onCellClick)="ShowImageDetail($event)"
               [focusedRowEnabled]="true"
              (onContentReady)="onContentReady($event)"

              >-->
<!--Opens image in another tab-->
<button class="btn btn-default" type="button" (click)="export()" title="Export - Print index copy">Export</button>
<dx-data-grid id="gridContainer"
              [dataSource]="recsresults"
              [remoteOperations]="remoteOps"
              [masterDetail]="{ enabled: false, template: 'detail' }"
              keyExpr="docID"
              (onInitialized)="onInitialized($event)"
              (onRowExpanding)="onExpanding($event)"
              (onCellClick)="imgClicked($event)"
              [showBorders]="true"
              [allowColumnResizing]="true"
              [columnResizingMode]="'widget'"
              [columnMinWidth]="150">

  <!--Don't open image in another tab'-->
  <!--<dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage"></dxo-state-storing>-->
  <dxo-load-panel [enabled]="true"></dxo-load-panel>
  <dxo-selection mode="single"></dxo-selection>
  <!--<dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage" [savingTimeout]="500"></dxo-state-storing>-->
  <dxo-scrolling mode="virtual" columnRenderingMode="virtual"></dxo-scrolling>
  <dxo-grouping [contextMenuEnabled]="true" [autoExpandAll]="false"></dxo-grouping>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-filter-row [visible]="showFilterRow"
                  [applyFilter]="currentFilter"></dxo-filter-row>
  <dxo-paging [enabled]="false"></dxo-paging>


  <!--<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>-->
  <!--<dxo-search-panel [visible]="true"
                        [width]="240"
                        placeholder="Search..."></dxo-search-panel>-->



  <dxi-column dataField="recordDate"
              dataType="date"
              format="MM/dd/yyyy"
              caption="Date"
              cellTemplate="cellDateTemplate"
              >
    <div *dxTemplate="let row of 'cellDateTemplate'; let i = index">
      <div id="div_{{row.data.docID}}_{{row.rowIndex}}" (mouseover)="mouseover($event)">
        {{row.data.recordDate | date:'MM/dd/yyyy'}}
      </div>
      <dx-tooltip target="#div_{{row.data.docID}}_{{row.rowIndex}}"
                  showEvent="dxhoverstart"
                  hideEvent="dxhoverend"
                  [contentTemplate]="infoFromServer">
        <div *dxTemplate="let data of 'infoFromServer'">
          <p>{{data}}</p>

        </div>
      </dx-tooltip>

    </div>

  </dxi-column>
  <dxi-column dataField="firstGrantor"
              caption="First Grantor">
  </dxi-column>
  <dxi-column dataField="firstGrantee"
              caption="First Grantee">
  </dxi-column>
  <dxi-column dataField="unparsedAddress"
              caption="Address">
  </dxi-column>
  <dxi-column dataField="cityTown"
              caption="City/Town">
  </dxi-column>
  <dxi-column dataField="docType"
              caption="Type">
  </dxi-column>
  <dxi-column dataField="recLandBP"
              caption="Book & Page">
  </dxi-column>
  <dxi-column [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="cellTemplate"
              [width]="50">
  </dxi-column>
  <div *dxTemplate="let row of 'cellTemplate'">

    <a target="_blank" [routerLink]='["/rec-name-doc-disp-pg", row.data.docID, row.data.recLandBook, row.data.recLandPage]' class="image">
      <img id="img_{{row.data.docID}}_{{row.rowIndex}}" src="images/document-icon-blue.png" (mouseover)="mouseover($event)"/>
      <dx-tooltip target="#img_{{row.data.docID}}_{{row.rowIndex}}"
                  showEvent="dxhoverstart"
                  hideEvent="dxhoverend"
                  [contentTemplate]="infoFromServer">
        <div *dxTemplate="let data of 'infoFromServer'">
          <p>{{data}}</p>

        </div>
      </dx-tooltip>
    </a>
  </div>
</dx-data-grid>
